// app/src/components/desktop/part/HomePageDesktopPart.tsx
import React, { useEffect, useState } from 'react';
import { UserType } from '../../../types';
import TextInputDesktop from '../atomicDesignDesktop/TextInputDesktop';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from "../../../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import SwitchDesktop from "../atomicDesignDesktop/SwitchDesktop";
import useLandingPageEmailParam from '../../../hooks/useLandingPageEmailParam';


const HomePageDesktopPart = () => {
	const { t } = useTranslation();
	const {
		handleUserAuthentication,
		loadingSignin,
	} = useAuthContext();
	const {
		initialEmailFromQueryParam,
		hasValidEmailQueryParam,
		consumeEmailQueryParam,
	} = useLandingPageEmailParam();
	const [email, setEmail] = useState(initialEmailFromQueryParam);
	const [isPro, setIsPro] = useState(false);
	const navigate = useNavigate();
	
	useEffect(() => {
		if (isPro) {
			const timer = setTimeout(() => {
				navigate('/pro');
			}, 300);
			
			return () => clearTimeout(timer);
		}
	}, [isPro, navigate]);

	useEffect(() => {
		if (!hasValidEmailQueryParam) {
			return;
		}

		consumeEmailQueryParam();
		handleUserAuthentication(initialEmailFromQueryParam, UserType.PART);
	}, [
		consumeEmailQueryParam,
		handleUserAuthentication,
		hasValidEmailQueryParam,
		initialEmailFromQueryParam,
	]);
	
	
	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		handleUserAuthentication(email, UserType.PART);
	};
	
	return (
		<div
			style={{
				width: 1761,
				height: 878,
				position: 'relative',
				background: '#F6F8FB',
				overflow: 'hidden',
				borderRadius: 32,
				color: '#323E48',
				marginBottom: 20,
			}}
		>
			<div
				style={{
					position: 'absolute',
					width: 1761,
					height: 683,
					borderRadius: '32px 32px 0px 0px',
					background: '#F6F8FB',
				}}
			/>
			<div
				style={{
					position: 'absolute',
					width: 928,
					height: 80,
					top: 95,
					left: 42,
					color: '#004D71',
					letterSpacing: 0,
					fontSize: 49,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontWeight: '500'
				}}
			>
				{t('homePagePart:title')}
			</div>
			
			<div
				style={{
					position: 'absolute',
					width: 928,
					height: 80,
					top: 165,
					left: 42,
					color: '#61AFA1',
					letterSpacing: 0,
					fontSize: 30,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontWeight: '500',
					textTransform: 'uppercase',
				}}
			>
				{t('homePagePart:subtitle')}
			</div>
			

			
			<SwitchDesktop isPro={isPro} setIsPro={setIsPro}/>
			<div
				style={{
					position: 'absolute',
					top: 255,
					left: 523,
					width: 535,
					height: 350,
					background: '#FFFFFF',
					boxShadow: '1px 1px 9px #00000029',
					borderRadius: 20,
					zIndex:3
				}}
			>
				<div style={{ position: 'relative' }}>
					<div
						style={{
							position: 'absolute',
							top: 90,
							right: -25,
							width: 50,
							height: 50,
							backgroundColor: '#FFFFFF',
							border: 'none',
							transform: 'rotate(-45deg)',
							boxShadow: '6px 6px 5px rgba(0, 0, 0, 0.1)',
						}}
					/>
					<div
						style={{
							position: 'absolute',
							top: 38,
							left: 30,
							width: 502,
							height: 280,
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
						}}
					>
						<div
							style={{
								fontSize: 25,
								fontWeight: 600,
							}}
						>
							{t('homePagePart:account_benefits')}
						</div>
						<div
							style={{
								height: 190,
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between',
								fontSize: 20,
								fontWeight: 500,
							}}>
							{[
								t("homePagePart:access_auctions"),
								t("homePagePart:manage_favorites"),
								t("homePagePart:alerts_prices"),
								t("homePagePart:alerts_sales"),
							].map((text, index) => (
								<div
									key={index}
									style={{
										fontSize: 20,
										display: 'flex',
										gap: 15,
									}}
								>
									<img
										src="/images/check-1.svg"
										alt="check"
										style={{ width: 20 }}
									/>
									{text}
								</div>
							))}
						</div>
						<div style={{ fontSize: 20, fontWeight: 500 }}>
							{t('page1:join_now')}
						</div>
					</div>
				</div>
			</div>
			<img
				src='/images/background-part.svg'
				alt="Car"
				style={{
					position: 'absolute',
					left: 50,
					bottom: 50,
					width: 'auto',
					height: 320,
					zIndex: 2,
				}}
			/>
			<form
				onSubmit={handleSubmit}
				style={{
					position: 'absolute',
					top: 255,
					left: 1112,
					width: 561,
					height: 418,
					background: '#FFFFFF',
					boxShadow: '0px 1px 6px #0F4D0029',
					borderRadius: 20,
				}}
			>
				<div style={{ position: 'relative' }}>
					<div
						style={{
							position: 'absolute',
							width: 533,
							height: 318,
							top: 52,
							left: 14,
							background: '#FFFFFF',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								position: 'absolute',
								top: 0,
								textAlign: 'center',
								fontWeight: 'bold',
								fontSize: 30,
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							{t('page1:login_signup')}
						</div>
						<div
							style={{
								position: 'absolute',
								top: 50,
								width: 124,
								height: 2,
								background: '#FF4D00',
							}}
						/>
						<div
							style={{
								position: 'absolute',
								top: 93,
								fontWeight: 'bold',
								fontSize: 20,
								width: '100%',
								textAlign: 'center',
							}}
						>
							{t('page1:enter_email')}
						</div>
						<div
							style={{
								position: 'absolute',
								top: 176,
							}}
						>
							<TextInputDesktop
								width={486}
								type="email"
								startIcon="@"
								placeholder="jean.dupont@gmail.com"
								value={email}
								onChange={(e) => setEmail(e.target.value.toLowerCase())}
								loading={loadingSignin}
							/>
						</div>
						<button
							type="submit"
							style={{
								position: 'absolute',
								bottom: 0,
								padding: '0px 20px',
								height: 48,
								borderRadius: 10,
								backgroundColor: '#FF4D00',
								color: '#FFFFFF',
								border: 'none',
								fontSize: 19,
								fontWeight: 'bold',
								cursor: 'pointer',
								textTransform: 'uppercase',
								fontFamily: 'Montserrat, sans-serif',
							}}
						>
							{t('page1:button_text')}
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};

export default HomePageDesktopPart;
